import { useCausesPortalAnalytics } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/useCausesDashboardAnalytics'
import { useAuthState } from '@percent/cause-dashboard/common/hooks'
import debounce from 'lodash/debounce'

interface ProductPageCTAClickProps {
  productName: string
  ctaContext: string
  ctaText: string
  ctaUrl: string
}

export const useProductPageAnalytics = () => {
  const { track, page } = useCausesPortalAnalytics()
  const { authState } = useAuthState()
  const { user } = authState

  const trackProductPageCTAClick = debounce(
    ({ productName, ctaContext, ctaText, ctaUrl }: ProductPageCTAClickProps) =>
      track('Product page CTA click', {
        ...(user?.id ? { accountId: user.id } : {}),
        productName,
        ctaContext,
        ctaText,
        ctaUrl
      }),
    1000
  )

  return {
    trackProductPageCTAClick,
    page
  }
}
